<template>
  <CRow>
    <CCol col="2 ml-2 mr-3">
      <div class="mb-1 text-center" v-if="Object.keys(row).length">
        <b-img-lazy v-if="String(row.map_image_url).trim().length" :src="row.map_image_url"
                    thumbnail fluid :alt="`Image: ${row.title}`" :title="`Image: ${row.title}`"
                    v-bind="mainProps"></b-img-lazy>
        <b-img v-else :src="require('@/assets/imgs/no-image-available.gif')"
               thumbnail fluid alt="Image not available"
               title="Image not available"></b-img>
      </div>
    </CCol>
    <CCol col="9">
      <label class="font-weight-bold text-crimson">Thông tin thêm:</label>
      <ul class="pl-4" v-if="Object.keys(row).length">
        <li>
          <strong>Loại tin: </strong>
          {{ row.news_type === 1 ? 'Tin tức' : 'Bản đồ quy hoạch' }}
        </li>
        <li>
          <strong>Loại quy hoạch: </strong>
          {{ row.zoning_type_name }}
        </li>
        <li>
          <strong>Giá xem tin: </strong>
          {{ fNumber(row.view_price) }} (coin)
        </li>
        <li>
          <strong>Lượt xem: </strong>
          {{ fNumber(row.view_count) }}
        </li>
        <li>
          <strong>Lượt like: </strong>
          {{ fNumber(row.like_count) }}
        </li>
        <li>
          <strong>Ngày cập nhật: </strong>
          {{ updateAt }}
        </li>
      </ul>
    </CCol>
  </CRow>
</template>

<script>
import moment from 'moment'
import {format} from '@/mixins/format'

export default {
  name: "ExpandInfoList",
  mixins: [
    format
  ],
  props: {
    row: {
      type: Object
    }
  },
  computed: {
    updateAt() {
      return moment(this.row.updated_at).format('YYYY/MM/DD - HH:mm:ss')
    }
  },
  data() {
    return {
      mainProps: {
        center: true,
        fluid: true,
        blank: true,
        blankColor: '#ccc',
        width: 600,
        height: 400
      }
    }
  }
}
</script>

<style scoped>
.img-thumbnail {
  border: 3px solid #ccc !important;
}
</style>
